import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { OKTA_CONFIG, OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { THEME_STORAGE_KEY, ThemeModule } from '@tylertech/cj-jpp-ui-core/theme';
import { DOMAIN_USER_ENDPOINT } from '@tylertech/cj-jpp-ui-core/authentication';
import { removeTrailingSlashes } from '@tylertech/cj-jpp-ui-core/utils';
import { SESSION_TIMEOUT_CONFIG, SessionTimeoutModule } from '@tylertech/cj-jpp-ui-core/session-timeout';
import { environment, productKey } from 'src/environments/environment';
import { httpInterceptorProviders } from './core/interceptors/interceptor.barrel';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { Configuration } from '@tylertech/cj-inmate-search-angular-sdk';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DOMAIN_INSTANCE_ENDPOINT, LoaderModule } from '@tylertech/cj-jpp-ui-core';
import { ErrorPageService } from "./modules/shared/services/error-page.service";
import { AppBarComponent } from './components/app-bar/app-bar.component';
import { SharedModule } from "./modules/shared/shared.module";
import { HostUtils } from "./utils/host.utils";
import {
  BrowserHostedImgHostService,
  ExternalHostedImgHostService,
  ImgHostServiceToken
} from "./core/services/host.service";
import { ConfirmationDialogComponent } from "./utils/confirmation-dialog/confirmation-dialog.component";
import { AppBodyCardComponent } from "./components/app-body-card/app-body-card.component";
import { PublicSearchComponent } from './pages/public-search/public-search.component';
import { InstanceHeaderComponent } from './components/instance-header/instance-header.component';
import { InstanceFooterComponent } from "./components/instance-footer/instance-footer.component";
import { InmateCardComponent } from './components/inmate-card/inmate-card.component';
import { PublicSearchSortFilterComponent } from './pages/public-search/public-search-sort-filter/public-search-sort-filter.component';
import { ListValueAccessorDirective } from './utils/_directives/list-value-accessor.directive';
import { DocInmateCardComponent } from './components/doc-inmate-card/doc-inmate-card.component';
import { DocInmateDetailsComponent } from './pages/public-search/doc-inmate-details/doc-inmate-details.component';
import { SearchStateComponent } from './components/search-state/search-state.component';

@NgModule({
  declarations: [
    AppComponent,
    AppBarComponent,
    ConfirmationDialogComponent,
    PublicSearchComponent,
    PublicSearchSortFilterComponent,
    ListValueAccessorDirective
  ],
  imports: [
    AppRoutingModule,
    BrowserModule,
    CoreModule,
    OktaAuthModule,
    SessionTimeoutModule,
    SharedModule,
    ThemeModule,
    FormsModule,
    LoaderModule,
    ReactiveFormsModule,
    AppBodyCardComponent,
    InstanceHeaderComponent,
    InstanceFooterComponent,
    InmateCardComponent,
    DocInmateCardComponent,
    DocInmateDetailsComponent,
    SearchStateComponent
  ],
  providers: [
    httpInterceptorProviders,
    { provide: THEME_STORAGE_KEY, useValue: `${productKey}#theme` },
    { provide: OKTA_CONFIG, useValue: { oktaAuth: new OktaAuth(environment.oidc) } },
    { provide: SESSION_TIMEOUT_CONFIG, useValue: environment.sessionTimeoutSettings },
    { provide: DOMAIN_USER_ENDPOINT, useValue: `${removeTrailingSlashes(environment.userApiUrl)}/profile` },
    { provide: DOMAIN_INSTANCE_ENDPOINT, useValue: `${removeTrailingSlashes(environment.userApiUrl)}/instances` },
    {
      provide: Configuration,
      useFactory: () => new Configuration({ basePath: environment.ServiceApiUrl })
    },
    {
      provide: ImgHostServiceToken,
      useClass: HostUtils.isBrowserHosted() ? BrowserHostedImgHostService : ExternalHostedImgHostService
    },
    { provide: 'DEVICE_TOKEN_AUDIENCE', useValue: new URL(environment.ServiceApiUrl).hostname },
    { provide: ErrorPageService }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}